<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Source
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'source-index'}">
            Sources
          </router-link>
        </li>
        <li class="active">
          <span v-if="isCreate">Create</span>
          <span v-else>Edit</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">{{ title }}</h3>
            </div>
            <form class="form-horizontal" @submit.prevent="submit">
              <div class="box-body" style="overflow: unset;">
                <div v-if="error" class="alert alert-danger">
                  <a class="close"
                    @click="error = false">
                    &times;
                  </a>
                  {{ error }}
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      placeholder="Name"
                      v-model="vendor.name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Code <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="code"
                      placeholder="Code (2-digits character)"
                      maxlength="2"
                      v-model="vendor.code">
                  </div>
                </div>

                <div class="form-group">
                  <label for="contact_person"
                    class="col-sm-2 control-label">
                    Contact Person <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="contact_person"
                      placeholder="Contact Person"
                      v-model="vendor.contact_person">
                  </div>
                </div>

                <div class="form-group">
                  <label for="phone"
                    class="col-sm-2 control-label">
                    Phone <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="number"
                      class="form-control"
                      id="phone"
                      placeholder="Phone"
                      min="8"
                      v-model="vendor.phone">
                  </div>
                </div>

                <div class="form-group">
                  <label for="email"
                    class="col-sm-2 control-label">
                    Email <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      placeholder="Email"
                      v-model="vendor.email">
                  </div>
                </div>

                <div class="form-group">
                  <label for="description"
                    class="col-sm-2 control-label">
                    Description
                  </label>

                  <div class="col-sm-10">
                    <ckeditor
                      id="description"
                      v-model="vendor.description"
                      :config="configs.ckeditor">
                    </ckeditor>
                  </div>
                </div>
              </div>

              <div class="box-footer">
                <button type="submit" class="btn btn-info pull-right" v-if="isCreate">Create</button>
                <button type="submit" class="btn btn-info pull-right" v-else>Update</button>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
              </div>

            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Ckeditor from '@/components/modules/common/Ckeditor';
import Common from '@/mixins/Common';
import bus from '@/utils/bus';

export default {
  name: 'VendorForm',

  mixins: [Common],

  data() {
    return {
      title: 'Add New Source',

      vendor: {
        id: null,
        name: null,
        code: null,
        description: null,
        contact_person: null,
        phone: null,
        email: null,
      },

      error: null,

      configs: {
        ckeditor: {
          toolbar: [
            [
              'Styles',
              'Format',
              '-',
              'Bold',
              'Italic',
              'Strike',
              '-',
              'NumberedList',
              'BulletedList',
              '-',
              'Source',
            ],
          ],
          height: 300,
          extraPlugins: 'uploadimage',
          uploadUrl: '/static/temp/',
        },
      },
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    Ckeditor,
  },

  methods: {
    async fetch() {
      this.axios.get(`/vendors/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;

          this.vendor.id = data.id;
          this.vendor.name = data.name;
          this.vendor.code = data.code;
          this.vendor.description = data.description;
          this.vendor.contact_person = data.contact_person;
          this.vendor.phone = data.phone;
          this.vendor.email = data.email;
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }
        });
    },

    validate() {
      if (!this.vendor.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.vendor.contact_person) {
        this.$swal('Contact Person required', 'Please fill contact person to continue', 'warning');
        return false;
      }

      if (!this.vendor.code) {
        this.$swal('Source code required', 'Please fill source code to continue', 'warning');
        return false;
      }

      if (!this.vendor.code) {
        this.$swal('Source code required', 'Please fill source code to continue', 'warning');
        return false;
      }

      if (!this.vendor.email) {
        this.$swal('Email required', 'Please fill email to continue', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    create() {
      this.axios.post('/vendors', this.stringify(this.vendor))
        .then((response) => {
          console.log(response);
          bus.$emit('destroy-editor');
          this.$router.push({
            name: 'source-index',
          });
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.errors = error.response.data.errors;
          }

          if (error) {
            const vendor = this.vendor.name || 'vendor';
            this.$swal({
              title: 'Create Failed!',
              text: `Failed to create ${vendor}`,
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    update() {
      this.axios.put(`/vendors/${this.vendor.id}`, this.stringify(this.vendor))
        .then(() => {
          bus.$emit('destroy-editor');
          this.$router.push({
            name: 'source-index',
          });
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Create Failed!',
              text: `Failed to update ${this.vendor.name}`,
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    cancel() {
      bus.$emit('destroy-editor');
      this.$router.go(-1);
    },
  },

  created() {
    if (!this.isCreate) {
      this.fetch();
      this.title = 'Edit Product';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/vendors/Form.vue